export default __webpack_public_path__ + "img/dLKrupPi.72cd9477.svg";